export default __webpack_public_path__ + "static/media/pricing.fa9a30ec.jpg";